<template>
  <div class="upload-wrapper pa-3">
    <div>
      <v-file-input
        show-size
        dense
        outlined
        label="Choose file"
        @change="change"
        accept="image/*"
        style="width: 300px"
      ></v-file-input>
      <div v-if="prevUrl">
        <img class="preview" :src="prevUrl" />
      </div>
      <v-btn
        color="primary"
        class="mt-2"
        small
        :disabled="!file"
        @click="tryUploadImage"
        :loading="uploading"
        >Start upload</v-btn
      >
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      file: null,
      uploading: false,
      prevUrl: null,
    };
  },
  methods: {
    ...mapActions(["uploadImage"]),
    ...mapMutations(["ALERT_SUCCESS", "ALERT_ERROR"]),
    change(event) {
      if (event) {
        this.file = event;
        this.prevUrl = URL.createObjectURL(this.file);
      } else {
        this.file = null;
        this.prevUrl = null;
      }
    },
    async tryUploadImage() {
      this.uploading = true;
      const result = await this.uploadImage(this.file);
      if (result.succeed) {
        this.$emit("input", result.data);
        this.ALERT_SUCCESS("Uploaded");
        this.prevUrl = null;
        this.$emit("close");
      } else {
        this.ALERT_ERROR("Error when uploading");
      }
      this.uploading = false;
    },
  },
};
</script>

<style scoped>
.upload-wrapper {
  height: 100%;
  width: 100%;
  overflow-y: auto;
}
.preview {
  max-height: 400px;
  max-width: 100%;
}
</style>